import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { withAuthCreateContainer } from "~/Containers/ContainerCreate";
import { getUserProfile } from "~/api/getUser";
import Spinner from "react-bootstrap/Spinner";
import { axiosAuth } from "react-axios";

const UserProfileContainer = (props) => {
  const { data, loading, failure, render, userDir, request } = props;

  useEffect(() => {
    request(userDir);
  }, [userDir]);

  const profile = (data && data.data) || [];

  if (failure) {
    return <Redirect to={`/`} />;
  }

  return loading ? <Spinner animation="border" variant="secondary" /> : render({ profile, loading, failure });
};

UserProfileContainer.propTypes = {
  userDir: PropTypes.string.isRequired,
};

export default withAuthCreateContainer(getUserProfile, UserProfileContainer, axiosAuth);
